import differentSessionEndTime from 'app/codeSpecificLogic/requiredDetails/DifferentSessionEndTime/differentSessionEndTime';
import differentSessionStartTime from 'app/codeSpecificLogic/requiredDetails/DifferentSessionStartTime/differentSessionStartTime';
import { selectSpecialty } from 'app/containers/User/selectors';
import { getStore } from 'app/reduxStore/configureStore';
import SpecialtyName from 'shared/core/doctor/domain/SpecialtyName';
import { RamqSpecialistActCodeNatureType } from 'shared/medyx-core/types/ramq';

const DIFFERENT_SESSION_END_TIME_AVAILABLE_PER_SPECIALTY: Record<SpecialtyName, boolean> = {
  [SpecialtyName.ANESTHESIOLOGIST_INTENSIVIST]: false,
  [SpecialtyName.ANESTHESIOLOGIST]: false,
  [SpecialtyName.CARDIOLOGIST]: false,
  [SpecialtyName.ENDOCRINOLOGIST]: false,
  [SpecialtyName.GENERAL_SURGEON]: false,
  [SpecialtyName.INTERNIST]: true,
  [SpecialtyName.ORTHOPEDIC_SURGEON]: false,
  [SpecialtyName.OTOLARYNGOLOGIST]: false,
  [SpecialtyName.PNEUMOLOGIST]: false
};

const addStartTimeForMultipleVisitsIfNeeded = (actCode, allActCodes) => {
  if (!canApply(actCode, allActCodes)) return [];

  const userSpecialty: SpecialtyName = selectSpecialty()(getStore().getState());

  if (DIFFERENT_SESSION_END_TIME_AVAILABLE_PER_SPECIALTY[userSpecialty]) {
    return [...differentSessionEndTime.associatedFields, ...differentSessionStartTime.associatedFields];
  }

  return differentSessionStartTime.associatedFields;
};

const canApply = (actCode, allActCodes) => {
  if (allActCodes.length < 2) return false;
  if (actCode.natureType !== RamqSpecialistActCodeNatureType.VISITE) return false;
  if (actCode.isSupplement) return false;
  const actCodeIndex = allActCodes.findIndex(({ id }) => id === actCode.id);
  if (actCodeIndex < 1) return false;

  return allActCodes.some(
    (otherActCode) =>
      otherActCode.natureType === RamqSpecialistActCodeNatureType.VISITE && otherActCode.id !== actCode.id
  );
};

export default addStartTimeForMultipleVisitsIfNeeded;
